/**
 * SIATA Santa Elena radar calibration constants (client).
 */

export const SIATA_SANTA_ELENA_CALIBRATION_VERSION = "1.0.0";

export const SIATA_SANTA_ELENA_APPROVED_MANUAL_BOUNDS = {
  westLng: -75.85,
  southLat: 5.85,
  eastLng: -75.15,
  northLat: 6.55,
};

export const SIATA_SANTA_ELENA_GEOREF_SOURCES = {
  GEOTIFF: "geotiff",
  APPROVED_MANUAL: "approved_manual",
  ADMIN_CALIBRATED: "admin_calibrated",
  ENV_OVERRIDE: "env_override",
  DEVELOPMENT_PLACEHOLDER: "development_placeholder",
  CANDIDATE_PREVIEW: "candidate_preview",
};

export const SIATA_AMVA_CALIBRATION_REFERENCE_POINTS = [
  {
    id: "medellin",
    name: "Medellín city center",
    lng: -75.5636,
    lat: 6.2518,
    purpose: "AMVA alignment reference",
  },
  {
    id: "envigado",
    name: "Envigado",
    lng: -75.5906,
    lat: 6.1701,
    purpose: "south valley reference",
  },
  {
    id: "bello",
    name: "Bello",
    lng: -75.557,
    lat: 6.3369,
    purpose: "north valley reference",
  },
  {
    id: "itagui",
    name: "Itagüí",
    lng: -75.6133,
    lat: 6.1719,
    purpose: "south valley reference",
  },
  {
    id: "sabaneta",
    name: "Sabaneta",
    lng: -75.6153,
    lat: 6.1515,
    purpose: "south valley reference",
  },
  {
    id: "barbosa",
    name: "Barbosa",
    lng: -75.3314,
    lat: 6.4381,
    purpose: "east valley reference",
  },
  {
    id: "caldas",
    name: "Caldas",
    lng: -75.6353,
    lat: 6.0911,
    purpose: "south valley reference",
  },
];

export const SIATA_CALIBRATION_QA_CHECKLIST = [
  "Radar image centered over Aburrá Valley",
  "North/south valley extent plausible",
  "East/west mountain boundary plausible",
  "Medellín / Envigado / Bello relative positions plausible",
  "Radar image does not cover all Colombia",
  "SIATA gauges appear within radar coverage",
  "Selected point context still works",
  "BART / RainViewer layers still render",
  "Labels / alerts appear above radar overlay",
];
